/**
 * Created by chenzheyu on 2017/6/12.
 */
import XKdetailsBox from './src/detailsBox.vue'

XKdetailsBox.install = function (Vue) {
  Vue.component(XKdetailsBox.name, XKdetailsBox)
}

export default XKdetailsBox



// WEBPACK FOOTER //
// ./src/components/module/detailsBox/index.js